(() => {
  if (window.nxStickyCartModule) {
    window.nxStickyCartModule();
    return;
  }

  const initStickyCarts = () => {
    document.querySelectorAll('[data-nx-sticky-cart]').forEach((bar) => {
      if (bar.dataset.nxStickyReady === 'true') return;

      const sectionId = bar.dataset.sectionId;
      const sourceButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const priceRoot = document.getElementById(`price-${sectionId}`);
      const stickyButton = bar.querySelector('[data-nx-sticky-button]');
      const stickyPrice = bar.querySelector('[data-nx-sticky-price]');
      if (!sourceButton || !stickyButton) return;
      bar.dataset.nxStickyReady = 'true';

      const sync = () => {
        const price = priceRoot?.querySelector('.price--on-sale .price-item--sale') ||
          priceRoot?.querySelector('.price__regular .price-item--regular');
        if (stickyPrice) stickyPrice.hidden = !priceRoot || priceRoot.classList.contains('hidden');
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim().replace(/\s+/g, ' ');
        stickyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
        const label = sourceButton.querySelector('span')?.textContent.trim();
        if (label) stickyButton.textContent = label;
      };

      const updateVisibility = () => {
        const footer = document.querySelector('.footer');
        const pastPurchaseArea = sourceButton.getBoundingClientRect().bottom < 0;
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        bar.classList.toggle('is-visible', pastPurchaseArea && !footerVisible);
      };

      let frame = 0;
      const scheduleVisibility = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          updateVisibility();
        });
      };

      stickyButton.addEventListener('click', () => {
        if (!stickyButton.disabled) sourceButton.click();
      });
      const buttonObserver = new MutationObserver(sync);
      buttonObserver.observe(sourceButton, { attributes: true, childList: true, subtree: true });
      const priceObserver = priceRoot ? new MutationObserver(sync) : null;
      priceObserver?.observe(priceRoot, { attributes: true, childList: true, characterData: true, subtree: true });
      window.addEventListener('scroll', scheduleVisibility, { passive: true });
      window.addEventListener('resize', scheduleVisibility);
      bar.nxStickyCleanup = () => {
        buttonObserver.disconnect();
        priceObserver?.disconnect();
        window.removeEventListener('scroll', scheduleVisibility);
        window.removeEventListener('resize', scheduleVisibility);
      };
      sync();
      updateVisibility();
    });
  };

  window.nxStickyCartModule = initStickyCarts;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCarts, { once: true });
  } else {
    initStickyCarts();
  }
  document.addEventListener('shopify:section:load', initStickyCarts);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-nx-sticky-cart]').forEach((bar) => bar.nxStickyCleanup?.());
  });
})();
